module.exports = __webpack_public_path__ + "static/media/certn-logo-invitation.744e037f.svg";